import {Component, Inject, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {Utilities} from '@shared/utilities/utilities.model';
import {DigitalSignUtilities} from '../../../../../../digital-sign/utilities/digital-sign-utilities.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DigitalSignSimpleClauseModel} from '@shared/components/core-sign/models/digital-signer.model';
import {ContentDialogDataModel, DigitalSignBaseService} from '@shared/components/core-sign/services/digital-sign-base-service';
import {MessageManagerService} from '@shared/service/message-manager/message-manager.service';
import {MessageManagerUtilities} from '@shared/service/message-manager/message-manager-utilities';
import {SignersType} from '@shared/components/core-sign/models/enums.model';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-digital-sign-content-file-dialog',
	templateUrl: './digital-sign-content-file-dialog.component.html',
	styleUrls: ['./digital-sign-content-file-dialog.component.scss']
})
export class DigitalSignContentFileDialogComponent implements OnInit {

	modeFixed: string = DigitalSignSimpleClauseModel.MODE_FIXED; //ci dice se un clausola è obligatoria.
	actionsAlignment: string;
	urlFile: any;
	absoluteUrlFile: any;
	title: string;
	token: string;
	pdfBuffer: ArrayBuffer;
	simpleClauses: DigitalSignSimpleClauseModel[];
	valueToChange: number;
	ready: boolean = false;
	indexFile: number;
	signer_type: SignersType;
	showProgressBar: boolean = false;
	private digitalSignService: DigitalSignBaseService;
	translateContext = TranslateContext;

	constructor(
		@Inject(MAT_DIALOG_DATA) private data: ContentDialogDataModel,
		public dialogRef: MatDialogRef<DigitalSignContentFileDialogComponent>,
		private sanitizer: DomSanitizer,
		private messageManagerService: MessageManagerService
	) {
		this.indexFile = this.data.indexFile;
		this.valueToChange = this.data.valueToChange;
		this.title = this.data.title;
		this.urlFile = this.data.urlFile;
		this.actionsAlignment = this.data.actionsAlignment;
		this.simpleClauses = this.data.simpleClauses;
		this.token = this.data.token;
		this.signer_type = this.data.signer_type;
		this.digitalSignService = this.data.service;
	}

	ngOnInit(): void {
		if (!Utilities.isVoid(this.token)) {
			this.loadInfocertDocument();
		} else {
			this.absoluteUrlFile = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlFile);
			this.ready = true;
		}
	}

	downloadInfocertDocument(): void {
		this.showProgressBar = true;
		this.digitalSignService.downloadFile(this.urlFile, this.token).subscribe(
			response => {
				if (!Utilities.isVoid(response) && response.status === 200) {
					Utilities.downloadFile(response, this.title);
					this.showProgressBar = false;
				}
			}, error => {
				this.messageManagerService.pushInnerMessage({...MessageManagerUtilities.getMessageDetailsFromResponse(error), ...{isTop: false}});
				this.showProgressBar = false;
			});
	}

	loadInfocertDocument(): void {
		this.digitalSignService.loadInfocertDocument(this.urlFile, this.token).subscribe(
			result => {
				if (!Utilities.isVoid(result)) {
					this.pdfBuffer = DigitalSignUtilities.base64ToArrayBuffer(Utilities.escapeBase64(result));
					this.ready = true;
				}
			}, error => {
				this.messageManagerService.pushInnerMessage({...MessageManagerUtilities.getMessageDetailsFromResponse(error), ...{isTop: false}});
			});
	}

	closeDialog(event: any): void {
		for (let i: number = 0; i < this.simpleClauses.length; i++) {
			if (this.simpleClauses[i].mode === this.modeFixed) {
				this.simpleClauses[i].values[this.valueToChange] = true;
			}
		}
		this.dialogRef.close(this.simpleClauses);
	}

}
